import {useEffect, useState} from 'react';
import {graphql, forecastFetchQuery} from '../../../graphql/forecastRelay';
import type {useWorkRolesQuery$data} from './__generated__/useWorkRolesQuery.graphql';

const WorkRolesQueryDoc = graphql`
	query useWorkRolesQuery {
		viewer {
			workRoles {
				id
				name
			}
		}
	}
`;

export interface WorkRoleOption {
	id: string;
	name: string;
}

export function useWorkRoles(): WorkRoleOption[] {
	const [roles, setRoles] = useState<WorkRoleOption[]>([]);

	useEffect(() => {
		let cancelled = false;
		forecastFetchQuery(WorkRolesQueryDoc, {})
			.then(data => {
				if (cancelled) return;
				const typed = data as useWorkRolesQuery$data | null;
				setRoles((typed?.viewer?.workRoles ?? []).map(r => ({id: r.id, name: r.name})));
			})
			.catch(() => {
				if (cancelled) return;
				setRoles([]);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return roles;
}
